import type { ReactNode } from 'react';
import { ShrinkToFit } from '@/components/ui/shrink-to-fit';

/**
 * One labelled data cell used by the winner-page token stats (Figma 3916-2710):
 * a translucent tile nested inside the stats `<Panel>` card — `rounded-panel-row`
 * is the concentric inner radius for a `rounded-card` panel with a `p-2` gap.
 */
export function StatTile({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}): React.ReactNode {
  return (
    <div className="flex min-w-0 flex-col gap-1 rounded-panel-row bg-background-tertiary/50 px-3 py-3">
      <span className="text-caption text-foreground-tertiary">{label}</span>
      <ShrinkToFit contentClassName="text-body-lg font-medium tabular-nums text-foreground-primary">
        {children}
      </ShrinkToFit>
    </div>
  );
}
